import React from 'react';
import * as Constants from '../constants';
import { useUtils } from "../hooks/useUtils";
import { HeadingBuilder } from './HeadingBuilder';

export const YesOrNoQs = ({
  headingTextYes, tippyAlertTextYes,
  buttonActionYes,
  headingTextNo, tippyAlertTextNo,
}) => {
  const { goBack } = useUtils();

  return (
    <>
      <HeadingBuilder
        headingText    = {headingTextYes}
        // Yes, ...
        buttonAction   = {buttonActionYes}
        goButtonText   = {Constants.GET_ICON_RT_ARROW}
        tippyAlertText = {tippyAlertTextYes}
        tippyText      = {Constants.DOT}
      />
      <br/>
      <HeadingBuilder
        headingText    = {headingTextNo}
        // No, don't ...
        buttonAction   = {goBack}
        goButtonText   = {Constants.GET_ICON_RT_ARROW}
        tippyAlertText = {tippyAlertTextNo}
        tippyText      = {Constants.DOT}
      />
    </>
  )
}

export default YesOrNoQs;